import { render, staticRenderFns } from "./insert-short-dialog.vue?vue&type=template&id=b089f306&scoped=true"
import script from "./insert-short-dialog.vue?vue&type=script&lang=js"
export * from "./insert-short-dialog.vue?vue&type=script&lang=js"
import style0 from "./insert-short-dialog.vue?vue&type=style&index=0&id=b089f306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089f306",
  null
  
)

export default component.exports